import engine from "./care_frameworks";
import { GROUPS } from "./cqcTaxonomy";
export const {
  definitions,
  PROFILE_VERSION,
  countryOf,
  addressReady,
  selectionFor,
  keysForProfile,
  profileReady,
} = engine;
export function groupsForSite(site, profile = site?.serviceProfile || {}) {
  const country = countryOf(site);
  if (country === "England")
    return GROUPS.map((g) => ({
      ...g,
      country,
      frameworkId: "england-cqc-saf-34",
      frameworkLabel: "England · CQC",
      regulator: "CQC",
    }));
  return engine.groupsForProfile(profile, country);
}
export function groupsForSites(sites) {
  const map = new Map();
  for (const site of sites)
    for (const g of groupsForSite(site)) {
      const old = map.get(g.id);
      map.set(
        g.id,
        old
          ? {
              ...old,
              items: [
                ...new Map(
                  [...old.items, ...g.items].map((i) => [i.id, i]),
                ).values(),
              ],
            }
          : g,
      );
    }
  return [...map.values()];
}
export function frameworkLabel(site) {
  const p = site?.serviceProfile || {},
    s = selectionFor(p, countryOf(site));
  return (
    s.frameworks.map((f) => `${f.regulator}: ${f.label}`).join(" + ") ||
    "Framework selection pending"
  );
}
